export default __webpack_public_path__ + "static/media/logo.cd7f6f6c.svg";